import React, { FC } from "react";
import { Table, Tooltip } from "antd";
import { YhBox } from "@/components/YhBox";
import { ColumnsType } from "antd/es/table";
import { useBmsSaleSoDetailModel } from "../bmsBillSaleSoModel";
import { RouterParamType } from "@/model/navModel";
import { IDetailList } from "../bmsBillSaleSoType"
export const TableBox: FC<RouterParamType> = () => {
    const { detailLookList, } = useBmsSaleSoDetailModel();
    const columns: ColumnsType<IDetailList> = [
        {
            title: '序号',
            width: 40,
            fixed: "left",
            render: (t: any, r: any, i: number) => i + 1
        }, {
            title: '配件编码',
            width: 120,
            dataIndex: 'materialCode',
            fixed: "left",
            // render: (text: any, record: any, index: number) => <Tooltip placement="topLeft" title={text}><p className="ellipsis click-span" onClick={() => onHistoryModel(record)}>{text}</p></Tooltip>,
        }, {
            title: '配件名称',
            width: 120,
            dataIndex: 'materialName',
            fixed: "left",
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            title: "单位",
            width: 60,
            dataIndex: 'unitName',
        },
        {
            title: '销售数量',
            width: 80,
            dataIndex: 'num',
        }, {
            title: '单价',
            width: 100,
            dataIndex: 'price',
        }, {
            title: '金额',
            width: 100,
            dataIndex: 'notAmount',
        }, {
            title: '折扣',
            width: 100,
            dataIndex: 'discountRate',
            render: (text: string) => text + '%'
        }, {
            title: '折后单价',
            width: 100,
            dataIndex: 'discountedPrice',
        }, {
            title: '零件金额',
            width: 100,
            dataIndex: 'amount',
        }, {
            title: '仓库',
            width: 140,
            dataIndex: 'warehouseName',
        }, {
            title: '货位',
            width: 140,
            dataIndex: 'shelfCode',
        }, {
            title: '可用库存',
            width: 120,
            dataIndex: 'inventoryNum',
            // }, {
            //     title: '可用库存',
            //     width: 120,
            //     dataIndex: 'availableStock',
        }, {
            title: '备注',
            width: 250,
            fixed: "right",
            dataIndex: 'note',
        }
    ];

    return (
        <YhBox title="配件信息" style={{ marginBottom: "75px" }}>
            <Table
                rowClassName='editable-row yh-edit-table-tr'
                rowKey={record => record.materialCode as string}
                columns={columns}
                dataSource={detailLookList}
                pagination={false}
                scroll={{ x: 'max-content' }}
            />
        </YhBox>
    )
}